<div class="zag-validity-dialog" role="dialog" aria-modal="true" aria-labelledby="zag-validity-dialog-title">
  <header class="zag-validity-dialog__header">
    <h2 id="zag-validity-dialog-title" class="zag-validity-dialog__title">{{ 'validity.dialog.title' | translate }}</h2>
    <button
      type="button"
      zagButton="basic"
      zagType="secondary"
      zagSize="sm"
      class="zag-validity-dialog__close"
      [attr.aria-label]="'common.close' | translate"
      (click)="onCancel()"
    >
      <span zagIcon="close" aria-hidden="true"></span>
    </button>
  </header>

  <div class="zag-validity-dialog__body">
    @if (data.extraContent) {
      <section class="zag-validity-dialog__extra">
        <ng-container [ngTemplateOutlet]="data.extraContent" />
      </section>
    }
    <section class="zag-validity-dialog__range" aria-labelledby="zag-validity-dialog-range-title">
      <h3 id="zag-validity-dialog-range-title" class="zag-validity-dialog__section-title">{{ 'validity.validityWindow' | translate }}</h3>
      <zag-date-range-picker
        [formControl]="rangeControl"
        [startPlaceholder]="'validity.start' | translate"
        [endPlaceholder]="'validity.end' | translate"
        [openRangeLabel]="'validity.end' | translate"
      />
    </section>

    <section class="zag-validity-dialog__recurrence" aria-labelledby="zag-validity-dialog-recurrence-title">
      <div class="zag-validity-dialog__recurrence-header">
        <h3 id="zag-validity-dialog-recurrence-title" class="zag-validity-dialog__section-title">
          {{ 'validity.recurrence' | translate }}
        </h3>
        <div class="zag-validity-dialog__recurrence-toggle">
          <span>{{ (recurrenceEnabled() ? 'validity.recurrenceToggle' : 'validity.noRecurrence') | translate }}</span>
          <zag-switch
            [checked]="recurrenceEnabled()"
            [ariaLabel]="(recurrenceEnabled() ? 'validity.recurrenceToggle' : 'validity.noRecurrence') | translate"
            (checkedChange)="onRecurrenceToggle($event)"
          />
        </div>
      </div>
      @if (recurrenceEnabled()) {
        <zag-rrule-editor
          [value]="rrule()"
          [startDate]="range().start ?? undefined"
          [endDate]="range().end ?? undefined"
          [showNever]="false"
          [showUntil]="false"
          (valueChange)="onRruleChange($event)"
        />
      }
    </section>
  </div>

  <footer class="zag-validity-dialog__footer">
    <button type="button" zagButton="outlined" zagType="secondary" (click)="onCancel()">
      {{ 'validity.dialog.cancelLabel' | translate }}
    </button>
    <button type="button" zagButton (click)="onApply()">
      {{ 'validity.dialog.applyLabel' | translate }}
    </button>
  </footer>
</div>
